import { ROLE_DATA } from "../../data/roles.js";
import { useGame } from "../../context/GameContext.jsx";
import { ClickablePlayer } from "./ClickablePlayer.jsx";

export function PlayerVoteCard({ player, onAdd, onRemove }) {
  const role = ROLE_DATA[player.baseRoleId];
  const hasRavenMark   = player.statuses.includes("raven_mark");
  const isInfected     = player.statuses.includes("infected");
  const isRogueWildChild = player.baseRoleId === "wild_child" && player.effectiveAlignment === "werewolf";
  const { state } = useGame();
  const session = state.session;
  const elderHasLife = player.baseRoleId === "elder" && player.alive && !session?.elder_usedSurvival;
  const elderLostLife = player.baseRoleId === "elder" && player.alive && session?.elder_usedSurvival;

  return (
    <div className={`flex items-center gap-3 rounded-2xl p-3 border
      ${player.voteCount > 0 ? "border-amber-500/60 bg-amber-950/30" : "border-amber-900/20 bg-stone-950/30"}`}>
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg shrink-0
        bg-gradient-to-br ${role?.gradient || "from-stone-800 to-stone-900"}`}>
        {role?.emoji || "?"}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          <ClickablePlayer player={player} className="text-sm" />
          {hasRavenMark && <span className="text-[10px] bg-slate-800 border border-slate-600 rounded px-1 text-slate-300 shrink-0">🦅+2</span>}
          {isInfected && <span className="text-[10px] bg-purple-950 border border-purple-700 rounded px-1 text-purple-300 shrink-0">🩸</span>}
          {isRogueWildChild && <span className="text-[10px] bg-red-950 border border-red-800 rounded px-1 text-red-300 shrink-0">🐺</span>}
          {elderHasLife && <span className="text-[10px] text-yellow-400 shrink-0">+1❤️</span>}
          {elderLostLife && <span className="text-[10px] text-stone-500 shrink-0">0💔</span>}
          {(player.sheepCount || 0) > 0 && <span className="text-[10px] text-stone-300 shrink-0">+{player.sheepCount}🐑</span>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={() => onRemove(player.id)}
          className="w-7 h-7 rounded-full bg-stone-800 border border-stone-700
            text-amber-400 flex items-center justify-center text-lg leading-none active:scale-95">−</button>
        <span className={`w-6 text-center font-bold text-base ${player.voteCount > 0 ? "text-amber-300" : "text-stone-600"}`}>
          {player.voteCount}
        </span>
        <button onClick={() => onAdd(player.id)}
          className="w-7 h-7 rounded-full bg-amber-900/60 border border-amber-700/60
            text-amber-300 flex items-center justify-center text-lg leading-none active:scale-95">+</button>
      </div>
    </div>
  );
}
